import { 
  PermissionObject,
  hasPermission,
  Role,
  aggregatePermissionsFromRoles,
  isStationOwner,
  canViewAllStations,
} from '@/types/permission';

export default (initialState: any) => {
  // Lấy thông tin user
  const currentUser = initialState?.currentUser;
  const publicUserData = initialState?.publicUserData;
  
  // Nếu chưa đăng nhập, không có quyền gì
  if (!currentUser) {
    return {
      canViewDashboard: false,
      canViewContent: false,
      canViewDevicesPricing: false,
      canViewMap: false,
      canViewUsers: false,
      canViewRoles: false,
      canViewEVStations: false,
      canViewGatewayStations: false,
      canViewGatewayDevices: false,
      canViewReports: false,
    };
  }

  // Lấy permissions từ roles của user
  // Roles được load trong initialState từ userRoleService
  const userRoles: Role[] = publicUserData?.roles || currentUser?.roles || [];
  const userPermissions: PermissionObject[] = aggregatePermissionsFromRoles(userRoles);
  
  console.log(
    'User roles loaded:',
    userRoles.some(
      (role) => role.role_name.toLocaleLowerCase() === 'boss tpk ev',
    ),
  );
  console.log('User permissions aggregated:', userPermissions);
  console.log('User info:', {
    id: currentUser.id,
    email: currentUser.email,
    roles: userRoles.map(r => r.role_name),
    permissions: userPermissions,
  });

  // Define access controls dựa trên permissions
  return {
    // Route-level access
    canViewDashboard: hasPermission(userPermissions, 'dashboard', 'view'),
    canViewContent: hasPermission(userPermissions, 'content', 'view'),
    canViewDevicesPricing: hasPermission(
      userPermissions,
      'devices-pricing',
      'view',
    ),
    canViewMap: hasPermission(userPermissions, 'map', 'view'),
    canViewUsers: hasPermission(userPermissions, 'users', 'view'),
    canViewRoles: hasPermission(userPermissions, 'roles', 'view'),
    // owner_station có quyền xem stations (nhưng chỉ của mình)
    canViewEVStations:
      hasPermission(userPermissions, 'ev-stations', 'view') ||
      hasPermission(userPermissions, 'ev-stations', 'view-own'),
    canViewGatewayStations: hasPermission(userPermissions, 'gateway-stations', 'view'),
    canViewGatewayDevices: hasPermission(userPermissions, 'gateway-devices', 'view'),
    canViewReports: hasPermission(userPermissions, 'reports', 'view'),

    // Action-level access (có thể sử dụng trong components)
    canCreateContent: hasPermission(userPermissions, 'content', 'create'),
    canEditContent: hasPermission(userPermissions, 'content', 'edit'),
    canDeleteContent: hasPermission(userPermissions, 'content', 'delete'),

    canEditDevicesPricing: hasPermission(
      userPermissions,
      'devices-pricing',
      'edit',
    ),

    canManageRoutes: hasPermission(userPermissions, 'map', 'manage-routes'),
    canManageStations: hasPermission(userPermissions, 'map', 'manage-stations'),

    canCreateUser: hasPermission(userPermissions, 'users', 'create'),
    canEditUser: hasPermission(userPermissions, 'users', 'edit'),
    canDeleteUser: hasPermission(userPermissions, 'users', 'delete'),
    canManageRoles: hasPermission(userPermissions, 'users', 'manage-roles'),

    canCreateEVStation: hasPermission(userPermissions, 'ev-stations', 'create'),
    canEditEVStation: hasPermission(userPermissions, 'ev-stations', 'edit'),
    canDeleteEVStation: hasPermission(userPermissions, 'ev-stations', 'delete'),

    canCreateGatewayStation: hasPermission(userPermissions, 'gateway-stations', 'create'),
    canEditGatewayStation: hasPermission(userPermissions, 'gateway-stations', 'edit'),
    canDeleteGatewayStation: hasPermission(userPermissions, 'gateway-stations', 'delete'),

    canCreateGatewayDevice: hasPermission(userPermissions, 'gateway-devices', 'create'),
    canEditGatewayDevice: hasPermission(userPermissions, 'gateway-devices', 'edit'),
    canDeleteGatewayDevice: hasPermission(userPermissions, 'gateway-devices', 'delete'),

    canExportReports: hasPermission(userPermissions, 'reports', 'export'),

    // Admin check
    isAdmin: userRoles.some(
      (role) => role.role_name.toLocaleLowerCase() === 'boss tpk ev',
    ),

    // Station owner check
    isStationOwner: isStationOwner(userPermissions),
    canViewAllStations: canViewAllStations(userPermissions),

    // Helper để check bất kỳ permission nào
    hasPermissionByRoute: (route: string, action: string) =>
      hasPermission(userPermissions, route, action),
  };
};
